/**
 * @fileoverview Organism: the persistent brand bar above every route.
 * @module components/organisms/AppHeader
 *
 * @description
 * Rendered once by {@link App}, not per page: the app name sits top-left
 * across the whole session, with the section switcher on the right.
 */

import { NavLink } from "react-router-dom"

import { Icon } from "@/components/atoms"

import "./AppHeader.css"

/**
 * Top app bar: logo and name top-left, section nav top-right.
 *
 * @returns The rendered header.
 */
export function AppHeader() {
	return (
		<header className="app-header">
			<NavLink to="/" className="app-header__brand" end>
				<img
					className="app-header__logo"
					src="/favicon.svg"
					alt=""
					width={26}
					height={26}
				/>
				<span className="app-header__name">DailyPex</span>
			</NavLink>

			<nav className="app-header__nav" aria-label="Navigation principale">
				<NavLink
					to="/"
					end
					className={({ isActive }) =>
						`app-header__link${isActive ? " app-header__link--active" : ""}`
					}
					aria-label="Habitudes"
				>
					<Icon name="home" size={20} />
					<span className="app-header__link-text">Habitudes</span>
				</NavLink>
				<NavLink
					to="/analytics"
					className={({ isActive }) =>
						`app-header__link${isActive ? " app-header__link--active" : ""}`
					}
					aria-label="Analytique"
				>
					<Icon name="chart" size={20} />
					<span className="app-header__link-text">Analytique</span>
				</NavLink>
			</nav>
		</header>
	)
}
